import React from 'react';
import { useController, useFormContext } from 'react-hook-form';

import { PlaceholderType } from 'shared/types';
import QuillEditor from 'components/quill-editor';

// import { NPSQuestionPlaceholders } from '../../../../constants';
import { useProductConfigContext } from 'shared/product-config-provider';

type QuestionTitleEditorProps = {
  open?: Boolean | undefined;
  body: any;
  questionIndex: any;
  questionType: any;
};

const QuestionTitleEditor = (props: QuestionTitleEditorProps) => {
  const { body, questionIndex, questionType } = props;
  const { control } = useFormContext();
  const { field, fieldState } = useController({
    name: `question_details.questions[${questionIndex}].text`,
    control,
    defaultValue: body,
  });

  const productConfig = useProductConfigContext();
  const NPSQuestionPlaceholders = productConfig?.NPSQuestionPlaceholders || [];
  const placeholders: PlaceholderType[] =
    questionType === 'RANGE' && NPSQuestionPlaceholders.length
      ? NPSQuestionPlaceholders.filter((a: any) => a.id !== 'nps')
      : NPSQuestionPlaceholders;

  return (
    <QuillEditor
      getValueAs="HTML"
      placeholders={placeholders}
      placeholder="Enter your question here"
      isErrored={Boolean(fieldState.error)}
      errorText={fieldState?.error?.message || ''}
      value={field.value}
      open={open}
      onChange={(val: string) => field.onChange(val)}
      maxCharLimit={300}
    />
  );
};

export default QuestionTitleEditor;
